import Sortable from 'sortablejs';

export const get_ag_ad = async (id:string):Promise<string> => {
    return new Promise<string>((resolve,reject) => {
        $.ajax({
            type: "get",
            url: `/ag-ad?id=${id}`,
            contentType: "application/x-www-form-urlencoded",
            dataType: "html",
            success: (ad_html) => {resolve(ad_html)},
            error: (xhr, textStatus, errorThrown) => {
                let errorMessage = xhr.responseText || textStatus;
                reject(new Error(errorMessage));
            }
        });
    });
};

const sortableToggle_toggleOnEvt = new CustomEvent("sortable.ag.toggleOn", {
    detail: {
        message: "Sortable element specified by data-ag-target is toggled on",
        time: new Date()
    },
    bubbles: true,
    cancelable: true
});
const sortableToggle_toggleOffEvt = new CustomEvent("sortable.ag.toggleOff", {
    detail: {
        message: "Sortable element specified by data-ag-target is toggled off",
        time: new Date()
    },
    bubbles: true,
    cancelable: true
});

export const init_ag_toggle_sortables = () => {
    $("[data-ag-toggle='sortable']").each(function(i, element) {
        let sortableEl:HTMLElement|null = document.getElementById(element.getAttribute("data-ag-target"))
        if (sortableEl == null) return;

        const sortable:Sortable = new Sortable(sortableEl, {
            disabled: element.getAttribute("aria-active") == "true"? false: true,
            // multiDrag: true,
            selectedClass: "bg-primary",
            // multiDragKey: null,
            avoidImplicitDeselect: false,
            onSelect: function(evt) {
            },
            onDeselect: function(evt) {
            }
        });
        element.addEventListener("click", function() {
            if ($(this).attr("aria-active") == "true") {

                sortable.option("disabled", true);
                $(this).attr("aria-active", "false");
                $(this).removeClass("active");
                this.dispatchEvent(sortableToggle_toggleOffEvt);
            } else {

                sortable.option("disabled", false);
                $(this).attr("aria-active","true");
                $(this).addClass("active");
                this.dispatchEvent(sortableToggle_toggleOnEvt);
            };
        });
    });
};